import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted } from 'vue';
import { getDiseaseFieldList_url } from '@/api'; //引入发送请求获取数据的方法

export default {
  components: {},
  name: 'companyIntro',
  setup: function setup() {
    onMounted(function () {
      getDiseaseFieldList();
    });
    var fieldList = ref([]);
    var activeNames = ref(-1);

    var getDiseaseFieldList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getDiseaseFieldList_url();

              case 2:
                res = _context.sent;
                fieldList.value = res.data; // console.log(res,'疾病领域列表')

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDiseaseFieldList() {
        return _ref.apply(this, arguments);
      };
    }(); // 展开方法


    var toggleMore = function toggleMore(index) {
      activeNames.value = index;
    }; // 收起方法


    var retract = function retract(name) {
      activeNames.value = -1;
    };

    return {
      fieldList: fieldList,
      activeNames: activeNames,
      retract: retract,
      toggleMore: toggleMore
    };
  }
};